export default "__VITE_ASSET__DU3qtyWD__"